import React from 'react'
import s from './TrainLowerPrice.less'

export const TrainLowerPrice = ({ price }) => <div className={s.root}>{price}</div>

export default TrainLowerPrice
